import axios from 'axios';
import { useStore } from './app/store';

export const baseURL = import.meta.env.VITE_API_URL + '/v1';
export const client = axios.create({
  baseURL,
});

client.interceptors.request.use(
  (request) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      request.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    // Get the selected workspace ID from the store
    const store = useStore.getState();
    const workspaceId = store.getSelectedWorkspaceId();
    if (workspaceId) {
      request.headers['x-workspaceid'] = workspaceId.toString();
    }

    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response) => response, // Directly return successful responses.
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== '/auth/refresh'
    ) {
      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
      try {
        const refreshToken = localStorage.getItem('refreshToken'); // Retrieve the stored refresh token.
        // Make a request to your auth server to refresh the token.
        const response = await client.post('/auth/refresh', {
          token: refreshToken,
        });
        const { accessToken, refreshToken: newRefreshToken } = response.data;
        // Store the new access and refresh tokens.
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', newRefreshToken);
        // Update the authorization header with the new access token.
        client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        return client(originalRequest); // Retry the original request with the new access token.
      } catch (refreshError) {
        // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
        console.error('Token refresh failed:', refreshError);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error); // For all other errors, return the error as is.
  }
);

// createAuthRefreshInterceptor(client, refreshAuth, {
//   statusCodes: [401], // default: [ 401 ]
//   pauseInstanceWhileRefreshing: true,
// });

// export const setHeaderToken = (token: string) => {
//   console.log('setting header token', token);
//   client.defaults.headers.common.Authorization = `Bearer ${token}`;
// };

// export const removeHeaderToken = () => {
//   delete client.defaults.headers.common.Authorization;
// };
